import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { CreateNpsAnswerItem } from '@/Network/Types/Requests/NpsRequests'

export default class NpsAnswerItemService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/answer-items'
  }

  async create(payload: CreateNpsAnswerItem): Promise<{ id: number }> {
    const response = await request.post<{ id: number }>(this.getCompletePath(), payload)
    return response.data
  }
}
